import { render, staticRenderFns } from "./ActiveEgiftOrders.vue?vue&type=template&id=b1648eac"
import script from "./ActiveEgiftOrders.vue?vue&type=script&lang=js"
export * from "./ActiveEgiftOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports